<template>
    <td-dialog
        :title="$t(title)"
        :before-close="orgDialogClose"
        :visible.sync="dialogOrgVisible"
        :width="modifyDialogWidth + 'px'"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-form :model="formOrgInfo" label-position="right" :label-width="formLabelWidth" ref="formOrgInfo" :rules="rules" style="margin-bottom:10px;">
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item :label="$t('common.NAME')" prop="sName">
                        <td-input v-model="formOrgInfo.sName" maxlength="100"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('common.NUMBER')" prop="sCode">
                        <td-input v-model="formOrgInfo.sCode" maxlength="100"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item :label="$t('common.PARENT_ORG')" prop="parentOrgName">
                        <td-select
                            :url="deptUrl"
                            keys="sId"
                            text="sName"
                            requestType="GET"
                            :isPage="true"
                            :placeholder="'common.PLEASE_SELECT'"
                            :pageSize="selectPageSize"
                            v-model="formOrgInfo.sParentId"
                            @change="belongDevChange"
                            v-bind:disabled="isDisabledType"
                        ></td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" style="padding-left:0px;">
                    <td-dynamic ref="tdDynamic" :label-width="formLabelWidth" v-model="extendElementValue" :groupFlg="groupFlg"> </td-dynamic>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item :label="$t('common.DESCRIPTION')" prop="description">
                        <td-input type="textarea" :rows="2" v-model="formOrgInfo.description" style="width:100%" :maxlength="200"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10" style="padding-top:10px;">
                <div class="userModuleInfo" style="width:100%;">
                    <el-row style="margin-left:20px;margin-top:20px;">
                        <el-col :span="10001">
                            <div class="userModuleInfoLogo"></div>
                        </el-col>
                        <el-col :span="10023" style="margin-left:20px;margin-top:-20px;">
                            <div style="font-weight:bold;">{{ $t('pgCommon.STATION_INFO') }}</div>
                        </el-col>
                    </el-row>
                    <el-row style="margin-left:20px;margin-bottom:20px;margin-top:20px;">
                        <td-checkbox-group
                            :hasBtn="false"
                            ref="roleCheckGroup"
                            :labelWidth="85"
                            :overLenghOmission="true"
                            v-model="checkList"
                            :allList="allStations"
                            keys="stationId"
                            text="stationName"
                            checkBoxClass="checkboxstyle"
                        ></td-checkbox-group>
                    </el-row>
                </div>
            </el-row>
        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="loading" @click="submitForm('formOrgInfo')">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('common.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import orgApi from './../assets/api.js';
export default {
    props: ['title', 'dialogOrgVisible', 'editItem', 'isAddData', 'editBaseOrg', 'modifyDialogWidth'],

    provide() {
        return {
            tdDynamicObjList: this.tdDynamicObjList
        };
    },

    created() {
        this.editItemNew = this.editItem;
        // 初始化职位信息
        this.initStation();
        if (!this.isAddData) {
            this.initEditData();
        } else {
            this.initAddData();
        }
    },

    mounted() {
        this.tdDynamicObjList.push(
            //应用类型初始化数据-移除人脸NVR
            {
                keyName: 'sLeaderId',
                operateType: 0,
                propsObjList: [
                    {
                        propsName: 'urlParam', //控件属性名
                        propsValue: {
                            leaderId: ''
                        }
                    }
                ]
            }
        );
    },
    // 定义变量
    data() {
        let validateCode = (rule, value, callback) => {
            let orgId = '';
            if (!this.isAddData) {
                orgId = this.editItemNew.sOrgId;
            }
            let param = {
                sOrgId: orgId,
                sCode: value
            };
            orgApi.checkStructureCodeRepeat(JSON.stringify(param), response => {
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('orgApi.checkStructureCodeRepeat', response);
                }
                if (response.data.content) {
                    callback(this.$t('pgCommon.SCODE_HAS_EXIST_PLEASE_INPUT'));
                    this.loading = false;
                    return;
                } else {
                    callback();
                }
            });
        };
        return {
            // 表单信息
            formOrgInfo: {
                sOrgId: '',
                sName: '',
                iType: '0',
                typeName: '',
                sParentName: '',
                sParentId: '0',
                sCode: '',
                description: ''
            },
            formStation: {},
            loading: false, // 保存按钮loading状态
            editItemNew: '',
            // 角色类型类型转换
            typeOptions: [],
            checkList: [],
            allStations: [],
            propertyInfoList: [],
            extendElementValue: {},
            tdDynamicObjList: [],
            formLabelWidth: '80px',
            isDisabledType: true,
            selectPageSize: 6,
            groupFlg: 'orgStructure',
            deptUrl: '/OrgStructureController/queryStructureData',
            // 对表单进行数据验证
            rules: {
                sName: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    // eslint-disable-next-line standard/object-curly-even-spacing
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }
                ],
                sCode: [
                    // eslint-disable-next-line standard/object-curly-even-spacing
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL'), trigger: 'blur' },
                    { validator: validateCode, trigger: 'blur' }
                ]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化职位信息
        initStation() {
            if (this.editItem == null || this.editItem == '') {
                return;
            }
            let content = {
                sOrgId: this.editItem.sOrgId
            };
            orgApi.queryStationInfo(content, response => {
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('orgApi.queryStationInfo', response);
                    return;
                }
                if (response.data.content != null) {
                    let stationInfo = response.data.content;
                    this.allStations = stationInfo.allStations;
                    // 为编辑状态则进行初始化数据
                    if (!this.isAddData && stationInfo.checkList != null && stationInfo.checkList.length > 0) {
                        this.checkList = stationInfo.checkList;
                    }
                }
            });
        },

        // 初始化编辑数据
        initEditData() {
            this.formOrgInfo.sOrgId = this.editItemNew.sOrgId;
            this.formOrgInfo.sName = this.editItemNew.sName;
            this.formOrgInfo.iType = this.editItemNew.iType;
            this.formOrgInfo.typeName = this.editItemNew.sTypeName;
            this.formOrgInfo.sParentId = this.editItemNew.sParentId === '0001' ? '0' : this.editItemNew.sParentName;
            this.formOrgInfo.description = this.editItemNew.sDescription;
            this.formOrgInfo.sCode = this.editItemNew.sCode;
            if (this.editItem.sExtendInfo) {
                try {
                    this.extendElementValue = JSON.parse(this.editItemNew.sExtendInfo.replace(/\\/g, ''));
                } catch (e) {
                    this.$message({
                        showClose: true,
                        message: this.$t('pgError.ERROR_MESSAGE_JSON'),
                        type: 'error'
                    });
                    this.$log.error('dialogOrgInfo.initEditData()', this.$t('pgError.ERROR_MESSAGE_JSON'));
                }
            }
        },

        // 初始化添加数据
        initAddData() {
            this.isDisabledType = false;
            this.formOrgInfo.sParentId = this.editItemNew.noPermission ? '0' : this.editItemNew.sParentId;
        },

        // 提交数据
        submitForm(formOrgInfo) {
            this.$refs[formOrgInfo].validate(valid => {
                //默认扩展校验通过
                let dynamicCheck = true;
                if (this.groupFlg) {
                    this.$refs.tdDynamic.$refs.dynamicForm.validate(validDynamic => {
                        dynamicCheck = validDynamic;
                    });
                }
                if (valid && dynamicCheck) {
                    let extendInfos = {};
                    if (this.groupFlg) {
                        extendInfos = this.$refs.tdDynamic.getfromInfo();
                    }
                    this.loading = true;
                    let content = {
                        sName: this.formOrgInfo.sName,
                        sDescription: this.formOrgInfo.description,
                        sCode: this.formOrgInfo.sCode,
                        sLeaderId: this.formOrgInfo.sLeaderId,
                        sExtendInfo: extendInfos,
                        sStationIds: this.checkList
                    };
                    if (this.isAddData) {
                        content.sParentId = this.formOrgInfo.sParentId;
                        orgApi.insertOrgStructure(JSON.stringify(content), response => {
                            this.loading = false;
                            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                                this.$log.error('orgApi.insertOrgStructure', response);
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('common.ADD_SUCCESS'), type: 'success' });
                            this.orgDialogClose();
                            this.$emit('reciveOrgInfoFromDialog', response.data.content, this.editBaseOrg);
                        });
                    } else {
                        content.sId = this.editItemNew.sOrgId;
                        content.sParentId = this.editItemNew.sParentId === '0001' ? null : this.editItemNew.sParentId;
                        orgApi.updateOrgStructure(JSON.stringify(content), response => {
                            this.loading = false;
                            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                                this.$log.error('orgApi.updateOrgStructure', response);
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('common.MODIFY_SUCCESS'), type: 'success' });
                            this.orgDialogClose();
                            this.$emit('reciveOrgInfoFromDialog', content, this.editBaseOrg);
                            this.$emit('queryTabList');
                        });
                    }
                }
            });
        },

        // 取消
        cancel() {
            this.orgDialogClose();
        },

        // 关闭窗口之前需要调用的方法
        orgDialogClose() {
            this.$emit('orgDialogClose');
            this.$refs['formOrgInfo'].resetFields(); // 重置表单数据
            this.editItemNew = null;
        }
    }
};
</script>
<style scoped>
.checkboxstyle {
    width: 165px;
    margin: 5px !important;
}
.el-card {
    padding-bottom: 26px;
}
/deep/.el-form-item__label {
    width: 25%;
}
</style>
